// ============================================================================= //
//  Animation modules
// ============================================================================= //
import "./animations/isInViewport";
//import "./animations/snapToSection";
import "./animations/splitTextIntoLines";
import "./animations/process";
import "./animations/projectReel";
import "./animations/projectReel";
import "./animations/photoGrid";
